var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActSidenavReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 5.6875C8.4324 5.6875 4 10.1199 4 15.5875V28.7875C4 34.2551 8.4324 38.6875 13.9 38.6875H27.1C32.5676 38.6875 37 34.2551 37 28.7875V22.7375C37 22.13 36.5075 21.6375 35.9 21.6375C35.2925 21.6375 34.8 22.13 34.8 22.7375V28.7875C34.8 33.0401 31.3526 36.4875 27.1 36.4875H13.9C9.6474 36.4875 6.2 33.0401 6.2 28.7875V15.5875C6.2 11.3349 9.6474 7.8875 13.9 7.8875H27.1C31.3526 7.8875 34.8 11.3349 34.8 15.5875V17.2375C34.8 17.845 35.2925 18.3375 35.9 18.3375C36.5075 18.3375 37 17.845 37 17.2375V15.5875C37 10.1199 32.5676 5.6875 27.1 5.6875H13.9Z",
    fill: "#9834F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6004 15.0375C21.6004 14.43 21.1079 13.9375 20.5004 13.9375C19.8929 13.9375 19.4004 14.43 19.4004 15.0375V28.7875C19.4004 29.395 19.8929 29.8875 20.5004 29.8875C21.1079 29.8875 21.6004 29.395 21.6004 28.7875V15.0375Z",
    fill: "#9834F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0008 18.8871C15.0008 18.2796 14.5083 17.7871 13.9008 17.7871C13.2933 17.7871 12.8008 18.2796 12.8008 18.8871V28.7871C12.8008 29.3946 13.2933 29.8871 13.9008 29.8871C14.5083 29.8871 15.0008 29.3946 15.0008 28.7871V18.8871Z",
    fill: "#9834F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2 23.2875C28.2 22.68 27.7075 22.1875 27.1 22.1875C26.4925 22.1875 26 22.68 26 23.2875V28.7875C26 29.395 26.4925 29.8875 27.1 29.8875C27.7075 29.8875 28.2 29.395 28.2 28.7875V23.2875Z",
    fill: "#9834F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActSidenavReports);
export default __webpack_public_path__ + "static/media/act_sidenav_reports.b5eb18d8c4aa67ff5648857d7c30cfc0.svg";
export { ForwardRef as ReactComponent };